import './index.scss'

interface LoadingIndicatorProps {
  fullScreen?: boolean
}

export default function LoadingIndicator(props: LoadingIndicatorProps = {
  fullScreen: true
}) {
  return <div className={(props.fullScreen === undefined || props.fullScreen === true) ? "loading-indicator full-screen" : 'loading-indicator'}>
    <div className='loading-spinner' />
  </div>
}